import { compose, withHandlers, withProps } from 'recompose';
import { map } from 'ramda';
import AcquisitionChannel from '../components/AcquisitionChannel';
import marketingLeadsProvider from '../../../customers/marketingLeads/hoc/marketingLeadsProvider';

const AcquisitionChannelContainer = compose(
  marketingLeadsProvider,
  withHandlers({
    onChange: props => (e) => {
      props.onChange(e.target.value);
    },
  }),
  withProps(props => ({
    options: map(item => ({ value: item.id, label: item.name }), props.marketingLeads),
    input: {
      onChange: props.onChange,
      value: props.value,
      disabled: props.disabled,
    },
  })),
);

export default AcquisitionChannelContainer(AcquisitionChannel);
